import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=731b3e87&scoped=true&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=731b3e87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b3e87",
  null
  
)

export default component.exports